import { app } from '@microsoft/teams-js';

function getTheme(theme) {
	return theme === 'dark' || theme === 'contrast' ? 'dark' : 'light';
}

export async function initializeTeams(setTheme) {
	await app.initialize();

	app.registerOnThemeChangeHandler((theme) => {
		setTheme(getTheme(theme));
	});

	const appContext = await app.getContext();

	setTheme(getTheme(appContext.app.theme));
}
